import { FixedSizeVirtualScrollStrategy } from "@angular/cdk/scrolling";

export class CustomVirtualScroll extends FixedSizeVirtualScrollStrategy
{
    constructor(){
        super(50,250,500)
    }
}